export default {
  route: '',
  errorFlag: 0
}
